import tableDictionary from './dictionary/calibration-office-commercial.dictionary';
import tableSettings from './settings/use-capacity-table.settings';

import * as _ from 'lodash';
import { BaseTable } from '../common-models/base-table.model';
import { CalibrationOfficeCommercialValue } from '../calibrations/calibration-office-commercial-value.model';
import { TableType } from '../../../shared/enums';

export class UseCapacityTable extends BaseTable {

    constructor() {
        super(tableSettings, tableDictionary, true);
        this.calibrationType = TableType.CALIBRATION_USE_CAPACITY;
    }

    public updateData(savedData: CalibrationOfficeCommercialValue[]): boolean {
        if (!this.isInitialized) {
            return false;
        }
        savedData.forEach((updatedCalibrationOfficeCommercial) => {
            const calibrationOfficeCommercialIndex =
                _.findIndex(this.table, (cell) => {
                    return cell.value.currentState.ZoneCombinationId === updatedCalibrationOfficeCommercial.ZoneCombinationId &&
                        cell.value.currentState.OverlayTypologyId === updatedCalibrationOfficeCommercial.OverlayTypologyId;
                });
            this.table[calibrationOfficeCommercialIndex].value =
                new CalibrationOfficeCommercialValue(updatedCalibrationOfficeCommercial, this.settings.fieldValidation);
        });

        return true;
    }
}
